import rootParams from './rootParams';

const getThreatActors = async (params) => {
  const myHeaders = new Headers();
  const token = localStorage.getItem('token');
  myHeaders.append('Authorization', `bearer ${token}`);

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow',
  };

  const baseUrl = `${rootParams.rootUrl}admin/dashboard/mitigations`;
  let url;

  if (params) {
    const queryParams = {};

    if (params.startDate) {
      queryParams.start_date = params.startDate;
    }

    if (params.endDate) {
      queryParams.end_date = params.endDate;
    }

    if (params.assetType) {
      queryParams.asset_type = params.assetType;
    }

    if (params.severity) {
      queryParams.severity = params.severity;
    }

    if (params.type) {
      queryParams.threat_actor_type = params.type;
    }

    if (params.client) {
      queryParams.client_name = params.client;
    }

    if (params.status) {
      queryParams.status = params.status;
    }

    if (params.page) {
      queryParams.page = params.page;
    }

    url = `${baseUrl}?${new URLSearchParams(queryParams)}`;
  } else {
    url = baseUrl;
  }

  const response = await fetch(url, requestOptions);

  if (!response.ok) {
    throw new Error('Get threat actors failed');
  }

  return response.json();
};

export default getThreatActors;
